interface HighlightProps {
  readonly text: string | undefined | null;
  readonly term: string | undefined | null;
}

export function Highlight({ text, term }: HighlightProps) {
  if (!text) return null;
  if (!term?.trim()) return <>{text}</>;

  const escapedTerm = term.replaceAll(/[.*+?^${}()|[\]\\]/g, String.raw`\$&`);
  const parts = text.split(new RegExp(`(${escapedTerm})`, 'gi'));

  return (
    <>
      {parts.map((part, i) => {
        const key = `${part}-${i}`;
        return part.toLowerCase() === term.toLowerCase() ? (
          <mark key={key} className="bg-yellow-200 text-inherit p-0 rounded-sm">
            {part}
          </mark>
        ) : (
          part
        );
      })}
    </>
  );
}
